"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_upload-button.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var DEVICE = 'DEVICE';
var SOURCE = 'SOURCE';

function onSelectUploadOption(_ref) {
  var onSourceFiles = _ref.onSourceFiles,
      onBrowseFiles = _ref.onBrowseFiles;
  return function (_ref2) {
    var value = _ref2.value;

    if (value === DEVICE) {
      return void onBrowseFiles();
    }

    onSourceFiles();
  };
}

function UploadButton(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "asset-selection-upload-btn__container"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.ElevatedContainer, {
    rounded: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "asset-selection-upload-btn"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    name: "importI",
    color: "regent",
    size: 35
  }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading5: true,
    noMargin: true
  }, "Drag and drop your assets"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    placeholder: true,
    noMargin: true
  }, "or use the options below"), /*#__PURE__*/_react.default.createElement(_uiKit.Dropdown, {
    type: "BUTTON",
    onChange: onSelectUploadOption(props),
    fixedButtonValue: true,
    options: [{
      label: 'My Device',
      prefix: 'folder',
      value: DEVICE
    }, {
      label: 'Media Library',
      prefix: 'medialibrary',
      value: SOURCE
    }],
    prefixSize: 15
  }, "Upload From"))));
}

var _default = /*#__PURE__*/(0, _react.memo)(UploadButton);

exports.default = _default;